import { _get, getUrlQueryParameterFromObject } from 'frontcore/utils/communications/apiClient'

const URL_MY_CALENDAR = 'utilities/my-calendar'

export function getMyCalendar ({ parameters, expanded = false }) {
  const queryParams = getUrlQueryParameterFromObject(parameters, false)
  let url = `${URL_MY_CALENDAR}/?${queryParams}`
  if (expanded) url += '&format=expanded'
  return _get(url)
}
